import React from "react";
import AnnouncementUnsubscribe from "../features/marketing/routes/AnnouncementUnsubscribe";

import { MarketingUnsubscribe } from "../features/marketing/routes/MarketingUnsubscribe";

import { HelpRoutes } from "../features/help/HelpRoutes";

export const commonRoutes = [
  {
    path: "/marketing/announcements/unsubscribe",
    element: <AnnouncementUnsubscribe />,
  },
  {
    path: "/marketing/announcements/unsubscribe/:token",
    element: <AnnouncementUnsubscribe />,
  },
  { path: "/help/*", element: <HelpRoutes /> },
  {
    path: "/marketing/unsubscribe/:uid/:token",
    element: <MarketingUnsubscribe />,
  },
];
